/**
 * ONE source of truth for how to connect Claude / ChatGPT to Rithmo, shared by the admin Connections page and the member
 * "Connect your AI assistant" steps so the two never diverge (connector-flow review item B). The address the steps refer to is
 * the canonical MCP endpoint (publicMcpUrl → /api/mcp), copied/shown beside these steps on each surface. ChatGPT follows
 * OpenAI's current custom-MCP-server path (Plugins → + → Add custom MCP server), and both acknowledge the account/workspace
 * restrictions. Claude also offers a prefilled add-connector deep link on the admin page; the written steps work either way.
 */
export const CONNECT_STEPS: Record<'claude' | 'chatgpt', string[]> = {
  claude: [
    'In Claude, open Settings → Connectors and choose Add custom connector (or use the prefilled link where offered).',
    'Name it Rithmo and use the address below.',
    'Choose Connect, then sign in to Rithmo and Allow — this approves your company’s agent library.',
  ],
  chatgpt: [
    'In ChatGPT, open Plugins → + → Add custom MCP server (Business, Enterprise or Edu; your workspace admin may need to enable it first).',
    'Enter the address below as the server URL, set authentication to OAuth, then create the plugin.',
    'Review the tools and install it, then sign in to Rithmo and Allow — this approves your company’s agent library.',
  ],
}
